export enum PaymentMethods {
  CARD = 'RecurringCard',
  ACH = 'ACH',
}

export enum PayNowPaymentMethods {
  EXISTING = 'ExistingMethod',
  NEW = 'NewMethod',
}

export enum PaymentActions {
  ADD_PAYMENT_METHOD = 'AddPaymentInfo',
  UPDATE_PAYMENT_METHOD = 'UpdatePaymentInfo',
  PAY_NOW_METHOD = 'PayNow',
  SHIPPING_PAYMENT = 'ShippingPayment',
}

export enum AccountTypesEnum {
  CHECKING = 'Checking',
  SAVINGS = 'Savings',
}

export enum ShippingPaymentMethods {
  CARD_ON_FILE = 'CardOnFile',
  NEW_CARD = 'NewCard',
  MARK_AS_PAID = 'MarkAsPaid',
}

export enum PaymentMethodStatus {
  ACH = 'ACH',
  CARD = 'RecurringCard',
  DIRECT = 'Direct',
  EXTERNAL = 'External',
  NOT_AVAILABLE = 'NotAvailable',
}

export enum PaymentStatus {
  Pending = 'Pending',
  Successful = 'Successful',
  Failed = 'Failed',
  NotAttempted = 'NotAttempted',
}